import StationElevationPlot, {StaElevPlotLayer} from "../outputs/ui/StationElevationPlot";
import React from "react";

export default function BridgePlot({br}) {

    return (
        <>
            <StationElevationPlot
                height={(window.innerHeight / 2) - 15}
                width={1000}
                layers={
                    [
                        StaElevPlotLayer.StaElevLayerNames.B_STA_ELEV,
                        StaElevPlotLayer.StaElevLayerNames.B_ABUTMENTS,
                        StaElevPlotLayer.StaElevLayerNames.B_PIERS,
                        StaElevPlotLayer.StaElevLayerNames.B_HIGH_CHORDS,
                        StaElevPlotLayer.StaElevLayerNames.B_LOW_CHORDS,
                        StaElevPlotLayer.StaElevLayerNames.B_LOW_HIGH_CHORDS,
                        StaElevPlotLayer.StaElevLayerNames.B_LOW_LOW_CHORDS,
                        StaElevPlotLayer.StaElevLayerNames.B_THALWEG,
                        StaElevPlotLayer.StaElevLayerNames.B_BANKS,
                        StaElevPlotLayer.StaElevLayerNames.B_WSEL_YR100,
                    ]
                }
                locWselEnable={false}
                globalVariables={{}}
                plotTitle={`${br?.cross_section} US (${br?.str_id})`}
                plotData={{
                    base: br?.plot_us_base
                }}
            />

            <StationElevationPlot
                height={(window.innerHeight / 2) - 15}
                width={1000}
                layers={[
                    StaElevPlotLayer.StaElevLayerNames.B_STA_ELEV,
                    StaElevPlotLayer.StaElevLayerNames.B_ABUTMENTS,
                    StaElevPlotLayer.StaElevLayerNames.B_PIERS,
                    StaElevPlotLayer.StaElevLayerNames.B_HIGH_CHORDS,
                    StaElevPlotLayer.StaElevLayerNames.B_LOW_CHORDS,
                    StaElevPlotLayer.StaElevLayerNames.B_LOW_HIGH_CHORDS,
                    StaElevPlotLayer.StaElevLayerNames.B_LOW_LOW_CHORDS,
                    StaElevPlotLayer.StaElevLayerNames.B_THALWEG,
                    StaElevPlotLayer.StaElevLayerNames.B_BANKS,
                    StaElevPlotLayer.StaElevLayerNames.B_WSEL_YR100,
                ]}
                locWselEnable={false}
                globalVariables={{}}
                plotTitle={`${br?.cross_section} DS (${br?.str_id})`}
                plotData={{
                    base: br?.plot_ds_base
                }}
            />
        </>
    )
}